module.exports = __webpack_public_path__ + "static/media/Onecrate_screen.3f12b61b.png";